/**
 * Form validation utilities
 */

export function isValidEmail(email: string): boolean {
  if (!email) return false;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function isValidUrl(url: string): boolean {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
}

export function isValidDutchPostalCode(postalCode: string): boolean {
  // Dutch postal code format: 4 digits + optional space + 2 letters
  // Examples: "1234 AB", "1234AB"
  const postalCodeRegex = /^\d{4}\s?[A-Za-z]{2}$/;
  return postalCodeRegex.test(postalCode.trim());
}
